module.exports = __webpack_public_path__ + "img/sender-owner.21d1f818.svg";